import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolLpAction } from '../symbolLp.action';

type IDependencies = IClientApiDependencySegment;

export const bulkRemoveSymbolLpEpic: IEpic<{}, IDependencies> = (action$, _state$, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolLpAction.bulkRemove.started),
  switchMap((params) => {
    return dependencies.api.bulkDeleteLpSymbols(params).pipe(
      mergeMap(() => [
        SymbolLpAction.bulkRemove.done({ params }),
        SymbolLpAction.loadUnmapped.started({ lpId: params.lpId }),
      ]),
      catchApiError((error) => [
        SymbolLpAction.bulkRemove.failed({ params, error }),
        createApiErrorNotification(error),
      ]),
    );
  }),
);
